import { Store } from '../../types';

export const remarksSelector = (state: Store): string => state.remarks;
